export enum EventSynchronisationName {
  filtresPret = 'filtresPret',
}
